"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as e } from "react/jsx-runtime";
import { useTheme as a } from "../../hooks.js";
import { useIsInverseVariant as i } from "../../theme-variant-context.js";
import { vars as o } from "../../skins/skin-contract.css-mistica.js";
const v = (_param)=>{
    var { color: t, size: c = 24 } = _param, h = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const n = i(), r = t !== null && t !== void 0 ? t : n ? o.colors.inverse : o.colors.neutralHigh, { skinName: m } = a();
    return m.match(/^o2-new/i) ? /* @__PURE__ */ e("svg", _object_spread_props(_object_spread({
        width: c,
        height: c,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, h), {
        children: /* @__PURE__ */ e("path", {
            fill: r,
            d: "M18.036 3.623c2.098.146 3.764 1.924 3.764 4.091 0 2.025-1.445 3.703-3.34 4.041v7.031C18.46 20.56 17.04 22 15.295 22h-6.33C7.218 22 5.8 20.56 5.8 18.786V5.214C5.8 3.44 7.218 2 8.965 2h6.33a3.15 3.15 0 0 1 2.741 1.623M19.5 7.179h1.198a3.05 3.05 0 0 0-1.576-2.162c.216.622.338 1.39.379 2.162m-1.053 1.075h-1.378c.081 1.513.491 2.354.69 2.491.197-.137.607-.978.688-2.491m-.689-3.566c-.198.137-.608.978-.689 2.491h1.378c-.081-1.513-.49-2.358-.689-2.491m-10.552.53v.174h7.216a4.07 4.07 0 0 1 1.99-1.545 1.72 1.72 0 0 0-1.116-.416h-6.33c-.973 0-1.76.804-1.76 1.787m7.612 1.961h1.198c.036-.772.162-1.536.378-2.162a3.04 3.04 0 0 0-1.576 2.162m1.576 3.237c-.216-.626-.342-1.39-.378-2.162h-1.198c.167.941.761 1.737 1.576 2.162m-1.098 10.158c.972 0 1.76-.805 1.76-1.788v-.178h-9.85v.178c0 .988.792 1.788 1.76 1.788zm-8.09-3.036h9.845v-5.783c-1.895-.338-3.34-2.02-3.34-4.04 0-.435.067-.856.193-1.249H7.205zM19.5 8.254c-.041.777-.163 1.54-.379 2.162a3.05 3.05 0 0 0 1.576-2.162z"
        })
    })) : /* @__PURE__ */ e("svg", _object_spread_props(_object_spread({
        width: c,
        height: c,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, h), {
        children: /* @__PURE__ */ e("path", {
            fill: r,
            d: "M18.036 3.623c2.098.146 3.764 1.924 3.764 4.091 0 2.025-1.445 3.703-3.34 4.041v7.031C18.46 20.56 17.04 22 15.295 22h-6.33C7.218 22 5.8 20.56 5.8 18.786V5.214C5.8 3.44 7.218 2 8.965 2h6.33a3.15 3.15 0 0 1 2.741 1.623M19.5 7.179h1.198a3.05 3.05 0 0 0-1.576-2.162c.216.622.338 1.39.379 2.162m-1.053 1.075h-1.378c.081 1.513.491 2.354.69 2.491.197-.137.607-.978.688-2.491m-.689-3.566c-.198.137-.608.978-.689 2.491h1.378c-.081-1.513-.49-2.358-.689-2.491m-10.552.53v.174h7.216a4.07 4.07 0 0 1 1.99-1.545 1.72 1.72 0 0 0-1.116-.416h-6.33c-.973 0-1.76.804-1.76 1.787m7.612 1.961h1.198c.036-.772.162-1.536.378-2.162a3.04 3.04 0 0 0-1.576 2.162m1.576 3.237c-.216-.626-.342-1.39-.378-2.162h-1.198c.167.941.761 1.737 1.576 2.162m-1.098 10.158c.972 0 1.76-.805 1.76-1.788v-.178h-9.85v.178c0 .988.792 1.788 1.76 1.788zm-8.09-3.036h9.845v-5.783c-1.895-.338-3.34-2.02-3.34-4.04 0-.435.067-.856.193-1.249H7.205zM19.5 8.254c-.041.777-.163 1.54-.379 2.162a3.05 3.05 0 0 0 1.576-2.162z"
        })
    }));
}, u = v;
export { u as default };
